
import { Component, Vue } from 'vue-property-decorator'
import { selectNewsInfo, defaultNewsData, updateNewsInfo } from '@/api/news'
import Pagination from '@/components/Pagination/index.vue'
import { INewsData } from '@/api/types'
import NewsPopper from '@/views/news/components/NewsPopper.vue'
@Component({
  components: { Pagination, NewsPopper }
})
export default class NewsPublished extends Vue {
  tableData: INewsData[] = [];
  dialogFlag = false
  listQuery = { page: 1, limit: 20, submitStatus: 1 };
  tempNewsData: INewsData = defaultNewsData
  dialogType = 'edit'
  total = 1
  baseUrl = 'https://www.etsme.com/news/detail/'
  created() {
    this.getList()
    if (window.location.origin.indexOf('test-') > -1) {
      this.baseUrl = 'http://test-www.etsme.com/'
    } else if (window.location.origin.indexOf('test2-') > -1) {
      this.baseUrl = 'http://test2-www.etsme.com/'
    } else {
      this.baseUrl = 'https://www.etsme.com/'
    }
  }

  public async getList() {
    const result = await selectNewsInfo(this.listQuery)
    this.tableData = result.data.list
    this.total = result.data.total
  }

  public edit(row:INewsData) {
    this.tempNewsData = Object.assign({}, row)
    this.dialogFlag = true
  }

  public closeDialog() {
    this.dialogFlag = false
  }

  public async saveData() {
    this.getList()
  }

  public toRecycleBin(row: any) {
    const _this = this
    this.$confirm('该删除文件将进入回收站中, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        _this.tempNewsData = Object.assign({}, row)
        _this.deleteData(row)
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
  }

  public async deleteData(row: INewsData) {
    this.tempNewsData = Object.assign({}, row)
    this.tempNewsData.submitStatus = 3
    const result = await updateNewsInfo(this.tempNewsData)
    if (result && result.code === 20000 && result.data > 0) {
      console.log(this.tableData)
      const index = this.tableData.findIndex(
        (v: INewsData) => v.id === this.tempNewsData.id
      )
      this.tableData.splice(index, 1)
      this.$message({
        type: 'success',
        message: '删除成功!'
      })
    }
  }
}
